import React, {Component} from 'react'
import {FormattedMessage} from 'react-intl'

class BillingMethodTotalLabel extends Component {

    constructor(props, context) {
        super(props, context)
        this.state = {
            billingMethod: this.props.value || '',
            billingMethodsCount: this.props.billingMethodsCount || 3,
        }
    }

    componentWillReceiveProps(nextProps) {
        this.setState({
            billingMethod: nextProps.value || '',
            billingMethodsCount: nextProps.billingMethodsCount || 3,
        })
    }

    render() {
        switch (this.state.billingMethod) {
            case "one-time":
                if (this.state.billingMethodsCount === 1) {
                    return <FormattedMessage
                        id="common.billing_method.total.label.single_label"
                        defaultMessage="Total"
                    />
                }
                return <FormattedMessage
                    id="common.billing_method.total.label.one_time"
                    defaultMessage="One time total"
                />
            case "monthly":
                return <FormattedMessage
                    id="common.billing_method.total.label.monthly"
                    defaultMessage="Monthly total"
                />
            case "yearly":
                return <FormattedMessage
                    id="common.billing_method.total.label.yearly"
                    defaultMessage="Yearly total"
                />
        }
        return ''
    }
}

export default BillingMethodTotalLabel





// WEBPACK FOOTER //
// ./src/common/pricing/billingmethodtotallabel.component.jsx